import { configureStore } from '@reduxjs/toolkit';
import { rootReducer } from './rootReducer';

// ----------------------------------------------------------------------

export function createDashboardStore(preloadedState) {
  return configureStore({
    reducer: rootReducer,
    preloadedState,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: false,
        immutableCheck: false,
      }),
  });
}

const store = createDashboardStore();

export { store };
